module.exports = __webpack_public_path__ + "static/media/circulo_E49D2A.04500362.svg";